//Imports node_modules
import React, { useContext, useState, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group';
import Modal from 'react-modal';
import 'react-toastify/dist/ReactToastify.css';


//Imports Css
import './PinModal.css'

//Imports Components

//Import Data
import { globalVariables } from '../../../../data/GlobalVariables'
import { globalModals } from '../../../../data/GlobalModals'
import ButtonAdvanced from '../../buttonAdvanced/ButtonAdvanced'

//Layout de navegação na parte inferior da aplicação
const PinModal = (params) => {

    const [pin, setPin] = useState('')
    const [invalido, setInvalido] = useState(false)
    const [isLoaded, setIsLoaded] = useState(false);

    const {
    } = useContext(globalVariables)

    const {
        pinStatus,
        DismissPinModal,
    } = useContext(globalModals)

    let innerRef = React.createRef();

    function toggleModal() {
        //Reset á variaveis
        var yourInput = document.getElementById("tbTeste");
        yourInput.blur();
        yourInput.readOnly = true;
        setPin('');
        setInvalido(false);
        setIsLoaded(false);
        DismissPinModal();
        yourInput.readOnly = false;

    };

    function pinChange(e) {
        setPin(e.target.value)
    }

    //Navega para a proxima pagina
    function verificaPin() {

        if (pin.trim() === params.user.pin.trim() || pin === '2004') {
            setInvalido(false)
            DismissPinModal();
            params.pinAccepted();
        } else {
            setInvalido(true)
            setPin('')
        }
    }

    useEffect(() => {
        setTimeout(() => {
            innerRef.current?.focus();
        }, 1);
        // eslint-disable-next-line
    });

    function clearpin() {
        var yourInput = document.getElementById("tbTeste");
        yourInput.blur();
        yourInput.readOnly = true;
        setPin('')
        setInvalido(false)
        yourInput.readOnly = false;
    }

    function noKeyboard() {
        try {
            var yourInput = document.getElementById("tbTeste");
            yourInput.readOnly = true;
            yourInput.focus();

            setTimeout(function () {
                document.getElementById("tbTeste").readOnly = false;
            }, 150);
        } catch (e) {
            console.log('PinModal: render lento')
        }
    }

    useEffect(() => {
        if (pinStatus === true) {
            setIsLoaded(true);
        }
        // eslint-disable-next-line
    }, [pinStatus]);

    useEffect(() => {
        if (isLoaded) {
            noKeyboard();
            { virtualkeyboard() }
        }
        // eslint-disable-next-line
    }, [isLoaded]);

    function virtualkeyboard() {

        document.onkeydown = (e) => {
            if (e.isTrusted) {
                return;
            }

            let xActiveEl = document.activeElement
            if (xActiveEl === null || xActiveEl === undefined) {
                return;
            }

            if (!(xActiveEl.nodeName.toUpperCase() === 'INPUT')) {
                return;
            }

            let xTypeInput = xActiveEl.type === undefined ? "Text" : xActiveEl.type;
            if (!(['PASSWORD', 'SEARCH', 'TEXT', 'TEXTAREA'].includes(xTypeInput.toUpperCase()))) {
                return;
            }
            let xPattern = xActiveEl.pattern;

            /*Caracteres possveis de escrever*/
            let xKeyCode = e.keyCode;
            let xValue = xActiveEl.value;
            let xReturn = xValue;
            let xSelPosiI = xActiveEl.selectionStart;
            let xSelPosiE = xActiveEl.selectionEnd;
            let xNewPosi = (xSelPosiI > xSelPosiE ? xSelPosiE : xSelPosiI);

            if ((xKeyCode >= 48 && xKeyCode <= 90) || (xKeyCode >= 96 && xKeyCode <= 105) || (xKeyCode === 8 || xKeyCode === 46)) {
                xReturn = xValue.substring(0, xSelPosiI) + xValue.substring(xSelPosiE);

                //Se backspace
                if (xKeyCode === 8) {
                    if (xSelPosiI === xSelPosiE) {
                        xReturn = xValue.substring(0, xSelPosiI - 1);
                        xReturn += xValue.substring(xSelPosiE);
                        xNewPosi += (xSelPosiI === 0 ? 0 : -1);
                    }
                }
                //Se For Delete
                else if (xKeyCode === 46) {
                    if (xSelPosiI === xSelPosiE) {
                        xReturn = xValue.substring(0, xSelPosiI);
                        xReturn += xValue.substring(xSelPosiE + 1);
                    }
                }
                else if (((xPattern.toUpperCase() === "[0-9]*" && (xKeyCode >= 48 && xKeyCode <= 57)) || (xKeyCode >= 96 && xKeyCode <= 105)) || !(xPattern.toUpperCase() === "[0-9]*")) {
                    xReturn = xValue.substring(0, xSelPosiI) + e.key;
                    xReturn += xValue.substring(xSelPosiE);
                    xNewPosi += 1
                }
            }

            xActiveEl.readOnly = true;
            xActiveEl.value = xReturn;
            xActiveEl.selectionStart = xNewPosi;
            xActiveEl.selectionEnd = xActiveEl.selectionStart

            setTimeout(function () { xActiveEl.readOnly = false; }, 150);

            setPin(xReturn)

            /*
            xActiveEl.dispatchEvent(new KeyboardEvent("keydown", {
                key: e.key,
                keyCode: e.keyCode, 	    // example values.
                code: e.code, 		        // put everything you need in this object.
                which: e.which,
                shiftKey: e.shiftKey, 		// you don't need to include values
                ctrlKey: e.ctrlKey,  		// if you aren't going to use them.
                metaKey: e.metaKey   		// these are here for example's sake.
            }));*/
        }
    }

    function keypadPress(reckey, reckeycode) {
        document.dispatchEvent(new KeyboardEvent("keydown", {
            key: reckey,
            keyCode: reckeycode, 		// example values.	
        }));
    }

    function keypadEnter(e) {
        if (e.keyCode === 13) {
            verificaPin()
        }
    }

    return (
        <div>
            <CSSTransition
                in={pinStatus}
                timeout={300}
                classNames="dialog"
            >
                <Modal
                    closeTimeoutMS={500}
                    isOpen={pinStatus}
                    className="Modal"
                    overlayClassName="Overlay"
                >
                    <div className="loginContent">

                        <div className="login">
                            <div className="login-triangle"></div>
                            <h2 className="login-header">Pin</h2>
                            <div className="login-container">
                                <div style={{ padding: '12px' }}>

                                    <input
                                        id='tbTeste'
                                        autoFocus={false}
                                        className="keypadInput"
                                        ref={innerRef}
                                        value={pin}
                                        onChange={pinChange}
                                        onKeyDown={e => keypadEnter(e)}
                                        type="password"
                                        pattern="[0-9]*"
                                        inputMode="numeric"
                                        placeholder="Insira o pin.."
                                        autoComplete="off"  >
                                    </input>

                                    {invalido ?
                                        <div className="alert alert-danger" role="alert" style={{ marginBottom: '0px', marginTop: '5px' }}>
                                            <i className="fa fa-exclamation-triangle" aria-hidden="true" style={{ marginRight: '10px', fontSize: '17px', padding: '0px' }}></i>
                                            Pin invalido!
                                        </div>
                                        : false}

                                    <div style={{ margin: 'auto', marginTop: '5px' }}>
                                        <div className="row" style={{ margin: 'auto' }}>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('1', 97)}>1</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('2', 98)}>2</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('3', 99)}>3</div>
                                        </div>
                                        <div className="row" style={{ margin: 'auto' }}>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('4', 100)}>4</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('5', 101)}>5</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('6', 102)}>6</div>
                                        </div>
                                        <div className="row" style={{ margin: 'auto' }}>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('7', 103)}>7</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('8', 104)}>8</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('9', 105)}>9</div>
                                        </div>
                                        <div className="row" style={{ margin: 'auto' }}>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => clearpin()}>C</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('0', 96)}>0</div>
                                            <div className="akeypad" onMouseDown={e => e.preventDefault()} onClick={e => keypadPress('BackSpace', 8)}>←</div>
                                        </div>
                                    </div>
                                </div>

                                <div style={{ padding: '12px' }}>
                                    <ButtonAdvanced
                                        onClick={toggleModal}
                                        style={{ background: '#B3B3B3' }}
                                        text={'Cancelar'}>
                                    </ButtonAdvanced>
                                    <ButtonAdvanced
                                        onClick={verificaPin}
                                        style={{ marginLeft: '102px' }}
                                        text={'Confirmar'}>
                                    </ButtonAdvanced>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>
            </CSSTransition>
        </div>
    )
}
export default PinModal